﻿import { useTranslation } from "react-i18next";
import TopBar from "@/pages/home/components/TopBar";
import Header from "@/pages/home/components/Header";
import CTABanner from "@/pages/home/components/CTABanner";
import OfferteForm from "@/pages/home/components/OfferteForm";
import WaaromWij from "@/pages/home/components/WaaromWij";
import Footer from "@/pages/home/components/Footer";
import StickyMobile from "@/pages/home/components/StickyMobile";
import Breadcrumb from "./components/Breadcrumb";
import HeroCompact from "./components/HeroCompact";
import IntroText from "./components/IntroText";
import DienstenRows from "./components/DienstenRows";
import Werkwijze from "./components/Werkwijze";

function SchemaMarkup() {
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Kozijn-, raam- en schuifpuireparatie Eindhoven",
    provider: {
      "@type": "LocalBusiness",
      name: "Ramen Repair Eindhoven",
      url: "https://ramen-repair-eindhoven.nl/",
      telephone: "+31407987470",
      email: "info@ramen-repair-eindhoven.nl",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Eindhoven",
        addressRegion: "Noord-Brabant",
        addressCountry: "NL",
      },
      areaServed: {
        "@type": "City",
        name: "Eindhoven",
      },
    },
    serviceType: [
      "Kozijnreparatie",
      "Raamreparatie",
      "Schuifpui reparatie",
      "Draaikiepraam afstellen",
      "Slot vervanging",
      "HR++ glas vervanging",
      "Velux dakraam reparatie",
      "Inbraakschade herstel",
      "Raamkruk vervanging",
      "Raamrubber vervanging",
    ],
    offers: {
      "@type": "AggregateOffer",
      priceCurrency: "EUR",
      lowPrice: "75",
      highPrice: "125",
      offerCount: "9",
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://ramen-repair-eindhoven.nl/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Onze diensten",
        item: "https://ramen-repair-eindhoven.nl/onze-diensten/",
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(serviceSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
    </>
  );
}

export default function Diensten() {
  const { t } = useTranslation("diensten");

  return (
    <main className="bg-white min-h-screen">
      <title>{t("seo.title", { defaultValue: "Onze diensten | Kozijn-, raam- en schuifpuireparatie Eindhoven" })}</title>
      <meta name="description" content={t("seo.description", { defaultValue: "Bekijk al onze diensten: kozijnreparatie PVC, alu, hout, schuifpui, draaikiep, slot en glas. Gratis offerte binnen 24 uur. Bel 040 798 7470." })} />
      <meta property="og:title" content={t("seo.title", { defaultValue: "Onze diensten | Kozijn-, raam- en schuifpuireparatie Eindhoven" })} />
      <meta property="og:description" content={t("seo.description", { defaultValue: "Bekijk al onze diensten: kozijnreparatie PVC, alu, hout, schuifpui, draaikiep, slot en glas. Gratis offerte binnen 24 uur. Bel 040 798 7470." })} />
      <meta property="og:locale" content="nl_NL" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://ramen-repair-eindhoven.nl/onze-diensten/" />
      <meta property="og:image" content="/og/og-home.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Ramen Repair Eindhoven - kozijn en raamreparatie" />
      <link rel="canonical" href="https://ramen-repair-eindhoven.nl/onze-diensten/" />
      <link rel="alternate" hreflang="nl-NL" href="https://ramen-repair-eindhoven.nl/onze-diensten/" />
      <link rel="alternate" hreflang="x-default" href="https://ramen-repair-eindhoven.nl/onze-diensten/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t("seo.title", { defaultValue: "Onze diensten | Kozijn-, raam- en schuifpuireparatie Eindhoven" })} />
      <meta name="twitter:description" content={t("seo.description", { defaultValue: "Bekijk al onze diensten: kozijnreparatie PVC, alu, hout, schuifpui, draaikiep, slot en glas. Gratis offerte binnen 24 uur. Bel 040 798 7470." })} />
      <meta name="twitter:image" content="/og/og-home.jpg" />
      <SchemaMarkup />
      <TopBar />
      <Header />
      <Breadcrumb />
      <HeroCompact />
      <IntroText />
      <DienstenRows />
      <Werkwijze />
      <WaaromWij />
      <CTABanner />
      <OfferteForm formUrl="https://formspree.io/f/xgoqdank" formId="offerte-aanvraag-diensten" />
      <Footer />
      <StickyMobile />
    </main>
  );
}